import { DateBox } from "devextreme-react"
import { useCrm } from "../../../Providers/CrmProvider"
import SelectBox from 'devextreme-react/select-box'
import { useParams } from "../../../Providers/ParamsProvider"

const CrmEventsFilter = ({ filterCriteria, setFilterCriteria }) => {
    const { crmEventTypesForContractor } = useCrm()
    const { isMobile } = useParams()

    const handleChangeFilter = (prop, value) => {
        setFilterCriteria(prev => ({
            ...prev,
            [prop]: value
        }))
    }

    const handleClearFilter = () => {
        setFilterCriteria({ type: null, dateFrom: null, dateTo: null })
    }

    return (<div className="d-flex flex-column flex-xl-row">
        <div className='date-filter'>
            <b>Zdarzenie</b>
            <SelectBox
                dataSource={crmEventTypesForContractor}
                placeholder='Wybierz zdarzenie'
                value={filterCriteria.type}
                onValueChanged={(e) => handleChangeFilter('type', e.value)}
                searchEnabled={true}
                searchMode="contains"
            />
        </div>
        <div className='date-filter ms-xl-3'>
            <b>Od</b>
            <DateBox
                acceptCustomValue={false}
                adaptivityEnabled={true}
                onValueChanged={(e) => handleChangeFilter('dateFrom', e.value)}
                value={filterCriteria.dateFrom}
                type="date"
                displayFormat="yyyy-MM-dd"
            />
        </div>
        <div className='date-filter ms-xl-3'>
            <b>Do</b>
            <DateBox
                acceptCustomValue={false}
                adaptivityEnabled={true}
                onValueChanged={(e) => handleChangeFilter('dateTo', e.value)}
                value={filterCriteria.dateTo}
                type="date"
                displayFormat="yyyy-MM-dd"
            />
        </div>
        <button style={{ fontSize: '15px', width: isMobile ? 'auto' : '40px', height: '40px' }} className='btn-app-primary mb-3 mb-xl-0 mt-xl-4 ms-xl-3' onClick={handleClearFilter}>X</button>
    </div>)
}

export default CrmEventsFilter